import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidatedResult } from '../../Models/Models/ValidatedResult';
import { ProcessType } from '../../Constants/Enums/Client/DashboardFilter/ProcessType';
import { GiaContributionModel } from '../../Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel';

declare var IS_RUNNING_IN_APP_POOL;

export class GiaContributionInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, headAccountHierarchyId: string, activityType: ProcessType): Promise<ValidatedResult<string>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/GiaContributionInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, headAccountHierarchyId: headAccountHierarchyId, activityType: activityType }

    return AjaxWrapper.post<ValidatedResult<string>, any>(url, data);
  }
  public get(hierarchyId: string, customerId: number, editAction: string, batchId: number): Promise<GiaContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/GiaContributionInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, customerId: customerId, editAction: editAction, batchId: batchId }

    return AjaxWrapper.get<GiaContributionModel, any>(url, data);
  }
  public put(model: GiaContributionModel, editAction: string): Promise<GiaContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/GiaContributionInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model, editAction: editAction }

    return AjaxWrapper.put<GiaContributionModel, any>(url, data);
  }
}

